import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import * as AT from '../../components/container/attributes';

export default class DayType extends MultiLanguageDesignationModel {
  constructor({
    id,
    number,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
    workingAllowed = undefined,
    active = undefined,
    defaultWorkDay = undefined,
    // We also need to add the key how it is stored in the db (we use the db column names)
    no = undefined,
    designation = undefined,
  }) {
    super({
      id,
      number: number || no,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    this.workingAllowed = workingAllowed;
    this.active = active;
    this.defaultWorkDay = defaultWorkDay;

    // For form items where we only store the designation in the data
    if (designation) {
      this.designation = designation;
    }
  }

  static get fkName() {
    return 'day_type_id';
  }
  static get apiRoute() {
    return 'day_type';
  }
  static get listPageRoute() {
    return 'dayTypeList';
  }
  static get detailPageRoute() {
    return 'dayTypeList';
  }
  static get createInitColumns() {
    return {};
  }
  get fkName() {
    return DayType.fkName;
  }
  get apiRoute() {
    return DayType.apiRoute;
  }
  get detailPageRoute() {
    return DayType.detailPageRoute;
  }
  get listPageRoute() {
    return DayType.listPageRoute;
  }
  static get config() {
    return {
      addable: false,
      duplicatable: false,
      importable: false,
      browsable: false,
      deletable: false,
    };
  }

  get config() {
    return DayType.config;
  }

  static get listDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'workingAllowed',
      'active',
    ]);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'workingAllowed',
    ]);
  }

  static get joinAttrsKey() {
    return [
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'workingAllowed',
    ];
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE(),
      new AT.BooleanAttribute({
        name: 'workingAllowed',
        creationValue: true,
        column: 'working_allowed',
        tableProperties: {
          header: 'hit-app.configuration.working-allowed',
          maxWidth: '0.5fr',
        },
      }),
      this.ACTIVE_ATTRIBUTE(),
      new AT.BooleanAttribute({
        name: 'defaultWorkDay',
        column: 'default_work_day',
      }),
    ].concat(
      this.generateMultiLanguageField({
        key: 'designation',
        attributeClass: AT.StringAttribute,
        header: 'hit-base.common.designation',
      }),
    );
  }
}
